import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

// Detects if a user was redirected to the Profile page from PrivateRoute because of missing phone number and coordinates the UI response
// If control and focusInputName is provided, it automatically sets errors and focuses on the input.
//It returns:
// isForcedEdit: Boolean used  to force-open edit forms or show alerts.
// initialTab: Number used to ensure the user lands on the correct tab in ProfilePage's chiptabs
export const useProfileSettingsState = (control = null, focusInputName="phoneNumber") => {
  const location = useLocation();
  const { t } = useTranslation();

  const isMissingPhone = !!location.state?.missingPhoneNumber;

  useEffect(() => {
    if (isMissingPhone && control) {
      control.setError("phoneNumber", {
        type: "custom",
        message: t("PleaseAddAPhoneNumber"),
      });

      // Auto-focus the field for better UX
      control.setFocus(focusInputName);
    }
  }, [isMissingPhone, control, t, focusInputName]);

  return {
    isForcedEdit: isMissingPhone,
    initialTab: location.state?.forceTab ?? 0,
  };
};
